export const columnStateMapping = {
  registered: ['registered'],
  qualifying: ['qualifying', 'qualifying_management_review', 'qualifying_approved'],
  certame: ['in_bidding'],
  negotiating: ['contracting', 'contracting_management_review'],
  implantation: ['contracting_finalization'],
  completed: ['completed'],
}

export type ColumnKey = keyof typeof columnStateMapping
